namespace Areas.Dialogs {
    "use strict";

    export class CreateChangeManagementEscalationDialog extends Areas.BaseDialog {

        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void, parameters: any) {
            super("CreateChangeManagementEscalation", closeHandler, parameters, () => {
                const form = $("#CreateChangeManagementEscalationForm").dxForm("instance");
                const formData: any = form.option("formData");

                formData.ChangeManagementAmount = parameters.reduce((amount, changeManagement, index, parameters) => {
                    return amount += changeManagement.changeManagementAmount;
                }, 0);

                formData.NumberOfDays = parameters.reduce((numberOfDays, changeManagement, index, parameters) => {
                    return numberOfDays += changeManagement.numberOfDays;
                }, 0)

                formData.ChangeManagementReasonLk = 'Escalation';

                const changeManagementType = parameters[0].changeManagementTypeLk;

                $.get(`/Dialog/CreateChangeManagementEscalation/GetEscalateToType/${changeManagementType}`,
                    (data) => {
                        formData.ChangeManagementTypeLk = data;
                        form.option("formData", formData);
                    });

            });
        }

        protected ok = (e: any) => {
            const form = $("#CreateChangeManagementEscalationForm").dxForm("instance");
            const result: any = form.validate();

            if (result.isValid) {

                const newData: any = form.option("formData");

                newData.ChangeManagementProfileId = this.parameters[0].changeManagementProfileId;
                newData.ChangeManagementIds = this.parameters.map(i => i.changeManagementId);

                sendRequest("/Dialog/CreateChangeManagementEscalation/Post", JSON.stringify(newData), "POST", () => {
                    this.close(DialogResult.Ok, null);
                });
            }
        }
    }

}